
import Icon from 'vux/src/components/icon/index.vue'

export default {
components:{
Icon
}
}



// WEBPACK FOOTER //
// ./src/pages/mobile/resultPay.vue